import gravatarUrl from "gravatar-url";
import moment from "moment";
import { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  conversationsApi,
  useGetConversationsQuery
} from "../../features/conversations/conversationsApi";
import getPartnerInfo from "../../utils/getPartnerInfo";
import Error from "../ui/Error";
import ChatItem from "./ChatItem";

export default function ChatItems() {
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const { user } = useSelector((state) => state.auth);
  const { email } = user || {};
  const { data, isLoading, isError, isSuccess, error } =
    useGetConversationsQuery(email) || {};

  const dispatch = useDispatch();

  const { data: conversations, totalCount } = data || {};

  const fetchMore = () => {
    setTimeout(() => {
      setPage((prev) => prev + 1);
    }, 2000);
  };

  useEffect(() => {
    if (page > 1) {
      dispatch(
        conversationsApi.endpoints.getMoreConversations.initiate({
          email: email,
          page,
        })
      );
    }
  }, [page, dispatch, email]);

  useEffect(() => {
    if (totalCount > 0) {
      const more =
        Math.ceil(
          totalCount / Number(process.env.REACT_APP_CONVERSATIONS_LIMIT_PER_PAGE)
        ) > page;
      setHasMore(more);
    }
  }, [totalCount, page]);

  let content = null;

  if (isLoading) {
    content = <li>Loading...</li>;
  } else if (isError) {
    content = (
      <li>
        <Error message={error?.message} />
      </li>
    );
  } else if (!isLoading && conversations?.length === 0) {
    content = <li>Conversation not found!</li>;
  } else if (isSuccess && conversations?.length > 0) {
    content = (
      <InfiniteScroll
        dataLength={conversations.length}
        next={fetchMore}
        hasMore={hasMore}
        loader={<h4>Loading...</h4>}
        height={window.innerHeight - 129}
      >
        {conversations
          .slice()
          .sort((a, b) => b.timestamp - a.timestamp)
          .map((conversation) => {
            const partner = getPartnerInfo(conversation.users, email);

            return (
              <li key={conversation.id}>
                <Link to={`/inbox/${conversation.id}`}>
                  <ChatItem
                    avatar={gravatarUrl(partner.email, { size: 80 })}
                    name={partner?.name}
                    lastMessage={conversation.message}
                    lastTime={moment(conversation.timestamp).fromNow()}
                  />
                </Link>
              </li>
            );
          })}
      </InfiniteScroll>
    );
  }

  return <ul>{content}</ul>;
}
